import {
  getApiV1ThreeLetterCodeClientAdminsStripeCreditCard,
  getGetApiV1ThreeLetterCodeClientAdminsStripeCreditCardKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import { nullifyNotFound } from '@fukuri-admins/utils/common';
import type { KeyedMutator } from 'swr';

type Args = {
  /** 企業コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** Stripe 既定カード情報。null = 未登録（404） */
  data: GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200 | null;
  /** データ再取得用の mutate 関数 */
  mutate: KeyedMutator<GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200 | null>;
};

type IUseGetStripeCreditCard = (args: Args) => ReturnType;

/**
 * 自社 Stripe Customer の既定カード情報取得フック
 *
 * カード払いでない、または既定カードが未設定（カード登録直後で Webhook 未反映等）の場合は
 * API が 404 を返す。fetcher が 404 を catch して null を返すことでエラー扱いにせず、
 * 呼び出し側（Container / logics）で「カード未登録」として表示を出し分けられるようにする。
 */
export const useGetStripeCreditCard: IUseGetStripeCreditCard = ({ threeLetterCode }) => {
  const { data, mutate } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsStripeCreditCardKey(threeLetterCode),
    () =>
      getApiV1ThreeLetterCodeClientAdminsStripeCreditCard(threeLetterCode).catch(nullifyNotFound),
    { suspense: true, shouldRetryOnError: false }
  );

  return { data, mutate };
};
